export default {
  title: "{{packageTypeName}} - Select Targets",
  joiningScheduled: "Joining Scheduled",
  searchPlaceholder: "Search by name or email",
  selectedCount: "{{count}} selected",
  nextStep: "Next",
  missingPackageInfo: "Package information not found",
  missingPackageInfoDescription:
    "Please select a package before accessing this page.",
  error: "An error occurred",
  errorDescription: "An error occurred while fetching data.",
  notSupported: "This feature is not supported",
  notSupportedDescription:
    "The target selection feature is not available for the selected package type.",
};
